<template>
    <select class="form-control" v-bind:multiple="multiple">
        <slot></slot>
    </select>
</template>

<script>
    export default {
        name: 'Select2',
        props: {
            value: null,
            options: {
                Object,
            },
            multiple: {
                Boolean,
                default: false,
            },
        },
        mounted: function() {

            let vm = this;
            let select = $(this.$el);

            // set up select2
            select.select2(this.options)
                .val(this.value) // set intial value of select2 from value in v-model
                .trigger("change") // update select2
                .on('change', function () {
                    vm.$emit('input', select.val()); // emit input event to send updated value to v-model
                });

        },
        destroyed: function() {

            // remove listeners and destroy select2
            $(this.$el).off().select2("destroy");

        },
        watch: {
            options: function(options) {

                // update select2 when options change
                $(this.$el).empty().select2(options);

            }
        },
    }
</script>
